<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<h2>Add Service</h2>
<fieldset>
    <div class="row">
        <div class="col-sm-6 mvd_form-group">
            <label class="required" title="* Required">Service</label>
            <p-autoComplete field="text" [(ngModel)]="service" [suggestions]="filteredServices"
                            (completeMethod)="filterServices($event)" (onSelect)="serviceChanged($event)"
                            [disabled]="serviceReadOnly" *ngIf="loadServiceAutoComplete">
            </p-autoComplete>
        </div>
        <div class="col-sm-6 mvd_form-group" *ngIf="enableCustomerField()">
            <customer-search-bar [label]="'Customer'" [autoHideSearch]="true" [customerNumberId]="customerNumberId"
                                 [readOnly]="readOnly || startingTransaction" [hideUntilLoaded]="!!customerNumberId" [includeDeceased]="false"
                                 (onItemSelected)="customerSelected($event)" (onItemRemoved)="customerRemoved()">
            </customer-search-bar>
            <p class="mvd_photo__required-not" *ngIf="photoFirstPresent && containsDriverTrans">
                Photo First Photo is still valid, a new photo is not required.
            </p>
        </div>
    </div>

    <div class="mvd_form-group" *ngIf="displayRequiredControl && showVehicleSearchComponent">
        <vehicle-search-bar [label]="'Vehicle'" [vehicleId]="serviceRequirementId" [readOnly]="readOnly || startingTransaction"
                            (onItemSelected)="vehicleSelected($event)" (onItemRemoved)="vehicleRemoved()">
        </vehicle-search-bar>
    </div>

    <div class="mvd_form-group" *ngIf="displayRequiredControl && showAircraftSearchComponent">
        <aircraft-search-bar [businessTransactionTypeId]="model.businessTransactionTypeId" [aircraftId]="aircraftId" [readOnly]="readOnly || startingTransaction"
                                   (onItemSelected)="onAircraftSelected($event)"
                                   (onItemRemoved)="onAircraftRemoved()">
        </aircraft-search-bar>
    </div>
</fieldset>

<ng-container *ngIf="displayRequiredControl && showTransactionTypeComponent && currentlySelectedCustomer">
    <tnr-transaction-type [customer]="currentlySelectedCustomer"
                          [businessTransactionTypeId]="model.businessTransactionTypeId"
                          [readOnly]="readOnly || startingTransaction"
                          (onBusinessTransactionParamSelected)="onBusinessTransactionParamSelected($event)"
                          (onBusinessTransactionParamRemoved)="onBusinessTransactionParamRemoved()">
    </tnr-transaction-type>
</ng-container>

<ng-container *ngIf="displayRequiredControl && showCommercialPermitSearchComponent && currentlySelectedCustomer">
    <cvp-transaction-type [customer]="currentlySelectedCustomer" [businessTransactionTypeId]="model.businessTransactionTypeId"
                          (onBusinessTransactionParamSelected)="onBusinessTransactionParamSelected($event)"
                          (onBusinessTransactionParamRemoved)="onBusinessTransactionParamRemoved()"
                          (handleDisplayError)="handleDisplayError($event)">
    </cvp-transaction-type>
</ng-container>

<ng-container *ngIf="displayRequiredControl && showIRPSearchComponent">
    <irp-transaction-type [businessTransactionTypeId]="model.businessTransactionTypeId"
                          [businessTransactionParamId]="businessTransactionParamId" [businessTransactionParamTypeId]="businessTransactionParamTypeId"
                          (onBusinessTransactionParamSelected)="onBusinessTransactionParamSelected($event)"
                          (onBusinessTransactionParamRemoved)="onBusinessTransactionParamRemoved()"
                          (displayInformationalMessage)="handleDisplayInformationalMessage($event)">
    </irp-transaction-type>
</ng-container>

<div class="well__footer">
    <div class="btn--group">
        <button class="btn--default" (click)="cancelPrequal()" [disabled]="startingTransaction">Cancel</button>
        <mvm-spinner-btn *ngIf="!showProceed && !navigateToTransaction" [btnText]="'Add'" [isLoading]="startingTransaction"
                         (clicked)="addNewService()" [isDisabled]="stopForValidationErrors || requiredFieldsNotFilled()">
        </mvm-spinner-btn>
        <mvm-spinner-btn *ngIf="!checkinMode && navigateToTransaction" [btnText]="'Proceed to Transaction'" [isLoading]="startingTransaction"
                         (clicked)="addNewService()">
        </mvm-spinner-btn>
        <mvm-spinner-btn *ngIf="showProceed" [btnText]="'Add'" [isLoading]="startingTransaction"
                         (clicked)="emitGreeterModel(serviceDetails)" [isDisabled]="(stopForValidationErrors && transactionValidationMode == 2) || requiredFieldsNotFilled()">
        </mvm-spinner-btn>
    </div>
</div>